export const ThumbaGiftPointIcon = ({ className }: { className?: string }) => {
  return <img alt="mirai-mile" src="/assets/miraimile.svg" className={className} />;
};
